import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const WAVE_COLOR = '#045C6F';

// The wave from Dynamica's welcome page. Decorative, so hidden from assistive
// technology; the copyright line under it is not.
export function WaveFooter() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{ display: { xs: 'none', md: 'block' }, position: 'relative' }}
    >
      <Box
        component="svg"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        sx={{
          display: 'block',
          width: '100%',
          height: '15vh',
          minHeight: 100,
          maxHeight: 150,
        }}
      >
        <defs>
          <path
            id="welcome-wave"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
          />
        </defs>
        <g>
          <use
            href="#welcome-wave"
            x="48"
            y="-2"
            fill={WAVE_COLOR}
            fillOpacity="0.5"
          />
          <use
            href="#welcome-wave"
            x="48"
            y="3"
            fill={WAVE_COLOR}
            fillOpacity="0.5"
          />
          <use
            href="#welcome-wave"
            x="48"
            y="4"
            fill={WAVE_COLOR}
            fillOpacity="0.3"
          />
          <use href="#welcome-wave" x="68" y="0" fill={WAVE_COLOR} />
        </g>
      </Box>
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          pb: 4,
          textAlign: 'center',
          color: 'var(--color-light-greyish-blue)',
          backgroundColor: WAVE_COLOR,
        }}
      >
        {t('auth.welcome.footer')}
      </Typography>
    </Box>
  );
}
